export default "__VITE_ASSET__D$LTJ5at__"